import { FormFieldTypes } from "../../../data/formFieldType";

export const CertificateDateModelConfig = {
  name: "CertificateDateModel",
  initialState: {
    issuanceDate: null,
    endDate: null,
  },
  formFields: [
    {
      id: "issuanceDate",
      lable: "Issuance Date",
      Field_Name: "Issuance Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "issuanceDate",
      fieldSetting: {
        placeholder: "Select",
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "endDate",
      lable: "End Date",
      Field_Name: "End Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "endDate",
      fieldSetting: {
        placeholder: "Select",
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
